import { ReactNode } from "react";

import { css } from "@compiled/react";
// @ts-ignore
import { useInView } from "react-intersection-observer";

import { token } from "@atlaskit/tokens";

import { Adg4Button } from "@/components/adg4/button/src";
import {
    DataEventProps,
    Row,
    TypographyStyles
} from "@/libraries/wpl/foundations/src";

/* arrows */

type ArrowProps = {
    color?: string;
    rotate?: number | string;
    className?: string;
};

const ArrowPencilPointRight = (props: ArrowProps) => {
    return (
        <svg
            className={props.className}
            style={{
                color: props.color ? props.color : "currentColor",
                transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
            }}
            width="72"
            height="25"
            viewBox="0 0 72 25"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z"
                fill="currentColor"
            />
        </svg>
    );
};

const ArrowPencilPointLeft = (props: ArrowProps) => {
    return (
        <svg
            className={props.className}
            style={{
                color: props.color ? props.color : "currentColor",
                transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
            }}
            width="72"
            height="24"
            viewBox="0 0 72 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.9227 9.89136C12.8559 10.3198 13.7536 10.3994 14.6425 10.5132C15.6079 10.6375 16.5536 10.5757 17.5121 10.3645C18.3557 10.175 19.219 10.2409 20.0279 10.4536C21.5408 10.855 23.0808 10.8711 24.6387 10.819C25.6115 10.7878 26.5986 10.7979 27.5595 10.9047C28.2255 10.9812 28.8622 11.2582 29.5419 11.4511C29.9165 10.8335 30.5174 10.8367 31.1428 11.0378C32.4341 11.4541 33.7522 11.4909 35.1039 11.4143C35.8394 11.3739 36.5714 11.5124 37.1884 11.9499C37.2673 12.001 37.3665 12.0246 37.4592 12.0536C38.0528 11.4497 38.7662 11.46 39.5105 11.5935C40.7067 11.8016 41.9108 11.9872 43.107 12.1954C43.9159 12.3387 44.7234 12.4993 45.5314 12.6542C46.3329 12.8144 47.1034 13.0593 47.9682 12.8307C49.0403 12.5458 50.1289 12.7587 51.2072 12.8844C52.4385 13.0312 53.6598 13.293 54.8886 13.3299C56.9895 13.3986 59.0603 13.6792 61.1439 13.8797C62.1414 13.9771 63.1418 14.0401 64.1298 14.1774C65.1356 14.3158 66.1374 14.5002 67.1254 14.7068C68.1781 14.9233 69.2262 15.1914 70.27 15.442C70.9467 15.6001 71.3431 16.1103 71.6547 16.6383C71.743 16.7882 71.5228 17.2018 71.3392 17.3982C70.7618 18.0204 70.0144 18.3373 69.155 18.4334C67.2256 18.6528 65.2988 18.6354 63.3794 18.5319C61.6553 18.4407 59.9427 18.2174 58.2364 17.9886C56.2648 17.7317 54.2832 17.5896 52.2903 17.5103C50.7359 17.4529 49.1846 17.2917 47.6327 17.2056C46.1819 17.12 44.7272 17.0804 43.27 17.0002C41.6589 16.9103 40.0473 16.8262 38.4337 16.6958C36.1459 16.5171 33.8679 16.2928 31.5805 16.1083C29.9551 15.9771 28.3292 15.8517 26.6791 16.0077C25.7428 16.099 24.7789 15.9574 23.8437 15.8292C22.4965 15.6462 21.1444 15.6593 19.7888 15.6433C18.1357 15.6259 16.4822 15.6142 14.8237 15.5907C14.3482 15.5838 13.8766 15.531 13.4011 15.5242C13.2708 15.516 13.1342 15.5825 13.001 15.6088C13.0562 15.7278 13.0778 15.8909 13.173 15.9604C13.7382 16.3773 14.3241 16.7607 14.8892 17.1776C16.3885 18.2886 17.8877 19.3997 19.38 20.5219C19.9556 20.9567 20.2952 21.5731 20.6541 22.1733C20.8725 22.5395 20.6963 22.8576 20.5166 23.1467C20.3439 23.4247 20.2332 23.8105 19.8124 23.8591C19.5238 23.8929 19.2352 23.9268 18.9432 23.9315C17.4944 23.9616 16.1902 23.4867 14.9044 22.9378C13.986 22.545 13.0829 22.1126 12.1507 21.742C11.7596 21.5845 11.518 21.3498 11.3464 20.9924C11.2252 20.7421 11.1271 20.4298 10.7245 20.7511C10.5458 20.89 10.3229 20.8529 10.1498 20.6513C9.89537 20.358 9.59702 20.0909 9.34308 19.7918C9.1705 19.5846 8.97812 19.5378 8.70533 19.5264C7.67779 19.5021 6.86056 19.0405 6.26148 18.2576C5.87639 17.7539 5.3694 17.4216 4.79922 17.2009C4.13681 16.9455 3.54102 16.6076 3.06516 16.1213C2.18987 15.2285 1.35949 14.2982 0.535518 13.3625C0.183447 12.9591 0.257735 12.1666 0.638219 11.7573C1.32072 11.0204 2.03035 10.3142 2.69609 9.56467C3.0524 9.15964 3.33129 8.68618 3.66048 8.25055C3.79472 8.07415 3.93392 7.8403 4.12436 7.77141C4.86836 7.49476 5.34066 6.91795 5.89038 6.40956C6.11689 6.19853 6.35721 5.96526 6.63547 5.84414C7.53885 5.44466 8.45209 5.06891 9.37962 4.73449C9.64998 4.63598 9.98638 4.73803 10.2912 4.72256C10.4289 4.7139 10.6341 4.68061 10.6894 4.59166C11.1746 3.79615 11.9181 3.38661 12.818 3.30462C14.1919 3.17737 15.4766 2.7037 16.7973 2.36515C18.3188 1.9757 19.8398 1.59199 21.3573 1.17919C22.5275 0.860049 23.7125 0.715138 24.9162 0.698488C25.4287 0.690319 25.8075 0.922123 26.0002 1.30974C26.4148 2.16189 26.512 2.13913 25.9069 2.94442C25.7924 3.09896 25.6611 3.24088 25.5693 3.4084C25.2149 4.06773 24.5597 4.21134 23.9149 4.44224C22.8097 4.8348 21.7288 5.29241 20.6532 5.75615C19.2436 6.36638 17.8547 7.01257 16.456 7.63504C15.7006 7.97452 14.9309 8.27266 14.1914 8.63624C13.4518 8.99982 12.7432 9.41734 11.9375 9.85763L11.9227 9.89136Z"
                fill="currentColor"
            />
        </svg>
    );
};

type ctaWithArrowsProps = {
    header: ReactNode | string;
    paragraph?: ReactNode | string;
    ctaProps: {
        ctaText: ReactNode | string;
        href: string;
        dataEventProps: DataEventProps;
    };
};

export const Adg4CtaWithArrows = ({
    header,
    paragraph,
    ctaProps
}: ctaWithArrowsProps) => {
    const { ref: scrollRef, inView: sectionIsVisible } = useInView();

    const noParagraphSpacing = !paragraph
        ? token("space.400")
        : token("space.200");

    return (
        <TypographyStyles>
            <section
                css={ctaStyles}
                ref={scrollRef}
                className={sectionIsVisible ? "is-visible" : ""}
            >
                <div className="arrows arrows-left">
                    <ArrowPencilPointRight
                        className="arrow1"
                        rotate={10}
                        color={"1868DB"}
                    />
                    <ArrowPencilPointRight
                        className="arrow2"
                        rotate={8}
                        color={"BC5DF2"}
                    />
                    <ArrowPencilPointRight
                        className="arrow3"
                        rotate={-6}
                        color={"101214"}
                    />
                    <ArrowPencilPointRight
                        className="arrow4"
                        rotate={-13}
                        color={"101214"}
                    />
                    <ArrowPencilPointRight
                        className="arrow5"
                        rotate={-15}
                        color={"FFA900"}
                    />
                    <ArrowPencilPointRight
                        className="arrow6"
                        rotate={-15}
                        color={"1868DB"}
                    />
                </div>
                <div className="arrows arrows-right">
                    <ArrowPencilPointLeft
                        className="arrow7"
                        rotate={-10}
                        color={"101214"}
                    />
                    <ArrowPencilPointLeft
                        className="arrow8"
                        rotate={-20}
                        color={"1868DB"}
                    />
                    <ArrowPencilPointLeft
                        className="arrow9"
                        rotate={5}
                        color={"82B536"}
                    />
                    <ArrowPencilPointLeft
                        className="arrow10"
                        rotate={5}
                        color={"1868DB"}
                    />
                    <ArrowPencilPointLeft
                        className="arrow11"
                        rotate={10}
                        color={"FFA900"}
                    />
                    <ArrowPencilPointLeft
                        className="arrow12"
                        rotate={10}
                        color={"101214"}
                    />
                </div>
                <Row layout="8">
                    <div className="row-width">
                        <h2 style={{ marginBottom: noParagraphSpacing }}>
                            {header}
                        </h2>
                        {paragraph && (
                            <Row layout="8">
                                <p className=".body-lg">{paragraph}</p>
                            </Row>
                        )}
                        <Adg4Button
                            variant="secondary"
                            color="black"
                            href={ctaProps.href}
                            dataEventProps={ctaProps.dataEventProps}
                        >
                            {ctaProps.ctaText}
                        </Adg4Button>
                    </div>
                </Row>
            </section>
        </TypographyStyles>
    );
};

const ctaStyles = css({
    "@keyframes arrow1": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineStart: "-100%",
            insetBlockStart: "20%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineStart: "-4%",
            insetBlockStart: "25%"
        }
    },
    "@keyframes arrow2": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineStart: "-100%",
            insetBlockStart: "25%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineStart: "50%",
            insetBlockStart: "35%"
        }
    },
    "@keyframes arrow3": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineStart: "-100%",
            insetBlockStart: "40%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineStart: "-2%",
            insetBlockStart: "40%"
        }
    },
    "@keyframes arrow4": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "110%",
            insetBlockStart: "50%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "0%",
            insetBlockStart: "50%"
        }
    },
    "@keyframes arrow5": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineStart: "-100%",
            insetBlockStart: "62%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineStart: "-2%",
            insetBlockStart: "60%"
        }
    },
    "@keyframes arrow6": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineStart: "-100%",
            insetBlockStart: "59%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineStart: "35%",
            insetBlockStart: "55%"
        }
    },
    "@keyframes arrow7": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "-100%",
            insetBlockStart: "10%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "-3%",
            insetBlockStart: "10%"
        }
    },
    "@keyframes arrow8": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "-100%",
            insetBlockStart: "10%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "40%",
            insetBlockStart: "18%"
        }
    },
    "@keyframes arrow9": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "-100%",
            insetBlockStart: "35%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "67%",
            insetBlockStart: "35%"
        }
    },
    "@keyframes arrow10": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "-100%",
            insetBlockStart: "35%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "25%",
            insetBlockStart: "35%"
        }
    },
    "@keyframes arrow11": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "-100%",
            insetBlockStart: "43%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "-5%",
            insetBlockStart: "43%"
        }
    },
    "@keyframes arrow12": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            insetInlineEnd: "-100%",
            insetBlockStart: "73%"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            insetInlineEnd: "25%",
            insetBlockStart: "63%"
        }
    },
    "position": "relative",
    "overflow": "hidden",
    "textAlign": "center",
    "padding": "100px 0",
    "display": "flex",
    "flexWrap": "wrap",

    "&.is-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        svg: {
            "&.arrow1": {
                animationName: "arrow1"
            },
            "&.arrow2": {
                animationName: "arrow2"
            },
            "&.arrow3": {
                animationName: "arrow3"
            },
            "&.arrow4": {
                animationName: "arrow4"
            },
            "&.arrow5": {
                animationName: "arrow5"
            },
            "&.arrow6": {
                animationName: "arrow6"
            },
            "&.arrow7": {
                animationName: "arrow7"
            },
            "&.arrow8": {
                animationName: "arrow8"
            },
            "&.arrow9": {
                animationName: "arrow9"
            },
            "&.arrow10": {
                animationName: "arrow10"
            },
            "&.arrow11": {
                animationName: "arrow11"
            },
            "&.arrow12": {
                animationName: "arrow12"
            }
        }
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".arrows": {
        "width": "22%",
        "position": "absolute",
        "insetBlockStart": 0,
        "insetBlockEnd": 0,

        "@media (max-width: 768px)": {
            "position": "relative",
            "width": "50%",
            "minHeight": "330px",
            "margin": "0 0 34px",

            "&.arrows-left": {
                transform: "rotate(45deg)"
            },

            "&.arrows-right": {
                transform: "rotate(-45deg)"
            }
        },

        "&.arrows-left": {
            insetInlineStart: 0
        },
        "&.arrows-right": {
            insetInlineEnd: 0
        },

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "svg": {
            position: "absolute",
            animationDuration: "1.5s",
            animationIterationCount: 1,
            animationFillMode: "forwards"
        }
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".row-width": {
        "padding": `${token("space.0")} ${token("space.500")}`,

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".half": {
            flexBasis: "100%"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h2": {
        marginBlockEnd: token("space.200")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "p": {
        marginBlockEnd: token("space.400")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".reduced-font-weight": {
        fontWeight: 400
    }
});
